module.exports = __webpack_public_path__ + "img/Mental Health Illness is Not a Weakness.3cd72f60.jpg";